import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { useContext } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import { getAnimationComponent } from './Animation.utils';
import { ChildrenPropType, ObjectPropsPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { createComponent } from '../../../foundation/services/components';
import { ON_OPTIONS } from '../../animation.constants';
import { AnimationsSettingsContext } from '../../context';
var propTypes = {
  children: ChildrenPropType,
  content: ChildrenPropType,
  className: PropTypes.string,
  on: PropTypes.oneOf(ON_OPTIONS).isRequired,
  animationName: PropTypes.string.isRequired,
  animationProps: ObjectPropsPropType
};
var defaultProps = {
  children: null,
  content: null,
  animationProps: {}
};
export default function Animation(_ref) {
  var content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    on = _ref.on,
    animationName = _ref.animationName,
    animationProps = _ref.animationProps;
  var finalContent = content || children;
  var animationsContext = useContext(AnimationsSettingsContext);
  if (!_get(animationsContext, 'enabled', true)) {
    return finalContent;
  }
  var AnimationComponent = getAnimationComponent(on, animationName);
  if (_isNil(AnimationComponent)) {
    return finalContent;
  }
  var finalClassName = classNames(_defineProperty({
    animation: true
  }, className, className));
  return createComponent(AnimationComponent, _objectSpread({
    className: finalClassName,
    content: content,
    children: children
  }, animationProps || {}));
}
Animation.propTypes = propTypes;
Animation.defaultProps = defaultProps;